export default "/images/429923839c55a9cb0d5bfcbdab2f155f.png";